import { ReactNode } from "react";

import IntersectionObserverWrapper from "components/IntersectionObserverWrapper";
import MetaHead from "components/MetaHead";
import BackgroundImage from "./components/BackgroundImage";
import Intro from "./components/Intro";
import CardsSection from "scenes/Sales/components/CardsSection";
import ContactForm from "./components/ContactForm";
import Timeline from "./components/Timeline";
import PackageCards from "./components/PackageCards";
import TabsWrapper from "./components/TabsWrapper";
import ExampleRealizations from "./components/ExampleRealizations";

type MatterportProps = {
  blogComponents: ReactNode | null;
};

const Matterport = ({ blogComponents }: MatterportProps) => (
  <>
    <MetaHead
      title="Profesionální prezentace pro vaši nemovitost"
      description="Zvyšte zájem o inzerci pomocí našich profesionálních služeb"
      canonicalUrl="https://www.ulovdomov.cz/vizualni-prezentace"
    />
    <BackgroundImage />
    <Intro />
    <TabsWrapper />
    <Timeline />
    <ExampleRealizations />
    <PackageCards />
    <ContactForm />
    <CardsSection />
    <IntersectionObserverWrapper>{blogComponents}</IntersectionObserverWrapper>
  </>
);

export default Matterport;
